import styled from '@emotion/styled'
import { CUSTOM_SCROLLBAR } from '@helpers/styles'
import { Box, Drawer as MuiDrawer, type Theme, Typography } from '@mui/material'

const DRAWER_WIDTH = 280

export const Drawer = styled(MuiDrawer)`
	background-color: transparent;
	flex-shrink: 0;
	overflow-x: hidden;
	white-space: nowrap;

	@media print {
		display: none !important;
	}

	&:hover {
		width: ${DRAWER_WIDTH}px;
	}

	${({ theme }: { theme: Theme }) => `
		transition: ${theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		})};
		width: ${theme.spacing(7)};

		${theme.breakpoints.up('sm')} {
			width: ${theme.spacing(8)};
		}
	`}

	& .MuiPaper-root {
		overflow-x: hidden;
		background-color: ${({ theme }: { theme: Theme }) =>
			theme.palette.background.paper};
		border-right: ${({ theme }: { theme: Theme }) =>
			`1px solid ${theme.palette.divider}`};

		${CUSTOM_SCROLLBAR.scrollbarCustomVertical}
		padding-right: 0;

		&:not(:hover) .MuiButtonBase-root {
			justify-content: center;

			& > h6 {
				display: none;
			}
		}

		&:not(:hover) .version-info {
			display: none;
		}

		&:hover {
			width: ${DRAWER_WIDTH}px;
		}

		${({ theme }: { theme: Theme }) => `
			transition: ${theme.transitions.create('width', {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			})};
			width: ${theme.spacing(7)};

			${theme.breakpoints.up('sm')} {
				width: ${theme.spacing(8)};
			}
		`}
	}
`

export const Toolbar = styled.div`
	display: flex;
	align-items: center;
	${({ theme }: { theme: Theme }) => `
		padding: ${theme.spacing(0, 0)};
	`}
`

export const MenuButtonBox = styled(Box)`
	${({ theme }: { theme: Theme }) => `
		height: ${theme.spacing(6)};
		width: ${theme.spacing(6)};
	`}
`

export const BottomDiv = styled.div`
	margin-top: auto;
`

export const VersionText = styled(Typography)`
	padding: ${({ theme }: { theme: Theme }) => theme.spacing(1, 2, 0)};
	color: ${({ theme }: { theme: Theme }) => theme.palette.text.secondary};
`
